
import { Base } from '../base-component';
import './content-cards.component.scss';

export class ContentCards extends Base {

	constructor(element: Element ) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/content-cards/content-cards.component.ts